const HOSTNAME = window.location.hostname

const getEnvironment = () => {
  if (HOSTNAME.startsWith('test') || HOSTNAME === 'localhost' ) {
    return 'test'
  }
  return 'prod'
}

const environment = getEnvironment()

const API_BASE_URLS = {
  test: 'https://test.xcars.kz',
  prod: 'https://xcars.kz'
}

export const AUTH_API_URL = `${API_BASE_URLS[environment]}/api-auth`
export const MISC_API_URL = `${API_BASE_URLS[environment]}/api-misc`
export const CAR_API_URL = `${API_BASE_URLS[environment]}/api-car`
export const CP_API_URL = `${API_BASE_URLS[environment]}/api-cp`
export const SALE_API_URL = `${API_BASE_URLS[environment]}/api-sale`
export const FB_API_URL = `${API_BASE_URLS[environment]}/api-fb`
